import request from '../utils/request'

/*
    获取省市区列表  
*/
export function regionInfo(data) {
    return request({
        url: '/globalRegionInfo/regionInfo',
        method: 'POST',
        data,
        noAuth: true
    })
}

/*
    个人中心-地址-获取用户地址列表  
*/
export function requestUserAddressList(data) {
    return request({
        url: '/yijiajiaUserAddress/requestUserAddressList',
        method: 'POST',
        data
    })
}

/*
    个人中心-地址-设置默认地址
*/
export function requestUserDefaultAddress(data) {
    return request({
        url: '/yijiajiaUserAddress/requestUserDefaultAddress',
        method: 'POST',
        data
    })
}

/*
    个人中心-地址-删除地址
*/
export function delUserAddress(data) {
    return request({
        url: '/yijiajiaUserAddress/delUserAddress',
        method: 'POST',
        data
    })
}

/*
    个人中心-地址-新增地址
*/
export function addUserAddress(data) {
    return request({
        url: '/yijiajiaUserAddress/addUserAddress',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}

/*
    个人中心-地址-编辑地址
*/
export function updateAddressByAddressId(data) {
    return request({
        url: '/yijiajiaUserAddress/updateAddressByAddressId',
        method: 'POST',
        data
    })
}